import { createTopNavLucideIcon } from "@dashboard/icons/createNavigationLucideIcon";
import { Images } from "lucide-react";

/**
 * The directory page's TopNav destination: back to the directory list.
 * Upstream's TopNav (3.23) names each destination with an icon and a
 * tooltip (TopNavDestinationIcon, topNavDestinationMessages); this section
 * keeps its own beside them rather than editing those files.
 */
export const AtticAssetsDestinationIcon = createTopNavLucideIcon(Images);
